import React from "react";
import MenuBase from "./MenuBase";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import PeopleRoundedIcon from "@mui/icons-material/PeopleRounded";
import EventIcon from "@mui/icons-material/Event";
import { useUser } from "../../contexts/UserContext";
import { canShowNiyazCalendarRegardlessOfAccess } from "../../util";

const MenuContentSectorAdmin = ({ open }) => {
  const { user } = useUser();
  const menuItems = [
    { label: "Dashboard", icon: <HomeRoundedIcon />, path: "/dashboard" },
    { label: "Jamaat", icon: <PeopleRoundedIcon />, path: "/jamaat" },
    ...(canShowNiyazCalendarRegardlessOfAccess(user)
      ? [{ label: "Niyaz Calendar", icon: <EventIcon />, path: "/niyaz-calendar" }]
      : []),
  ];

  return <MenuBase open={open} menuItems={menuItems} />;
};

export default MenuContentSectorAdmin;
